
    import './styles.scoped.css';
    export default {
  "navigation-container": "awsui_navigation-container_2p2ab_171ws_153",
  "is-navigation-open": "awsui_is-navigation-open_2p2ab_171ws_164",
  "navigation": "awsui_navigation_2p2ab_171ws_153",
  "hide-navigation": "awsui_hide-navigation_2p2ab_171ws_184"
};
  